import { $window, jqOffOn } from 'util/global';


const helpers = {};

helpers.setBackButton = (hash, callback, $closeButton) => {
    window.location.hash = hash;

    // Call the callback when the hash changes (because the user pushed the back button)
    jqOffOn($window, 'hashchange.backbutton', (e) => {
        if (window.location.hash.indexOf(hash) < 0) {
            callback(e);
            $window.off('hashchange.backbutton');
        }
    });

    jqOffOn($closeButton, 'click.backbutton', (e) => {
        if (window.history) {
            window.history.back(); // This will trigger the hashchange event
        } else {
            callback(e);
            helpers.removeBackButton();
        }
    });
};

helpers.removeBackButton = () => {
    window.hash = '';
    $window.off('hashchange.backbutton');
};


module.exports = helpers;
